import React, { useState, useEffect } from 'react';
import PageLayout from '../common/PageLayout';
import { CheckingKoreanDataUpdate } from '../utils/api/productApi';
import { handleImportProcess } from '../utils/fileHandlers/importHandler';
import '../css/Step1.css';

function CheckKrDataUpdate() {
    const [error, setError] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const [isConverting, setIsConverting] = useState(false);
    const [animatedText, setAnimatedText] = useState('Waiting...');
    const [serverLogs, setServerLogs] = useState([]);

    useEffect(() => {
        if (isConverting) {
            let currentIndex = 0;
            const fullText = 'Waiting...';
            const dots = '...';

            const timer = setInterval(() => {
                const numDots = (currentIndex % 4);  // 0에서 3까지 순환
                setAnimatedText(`${fullText}${dots.slice(0, numDots)}`);
                currentIndex++;
            }, 500);  // 타이머 간격을 500ms로 조정

            return () => clearInterval(timer);
        } else {
            setAnimatedText('Waiting...');  // converting 끝나면 원래 텍스트로
        }
    }, [isConverting]);

    const handleConvert = async () => {  // formData 파라미터 제거
        setError("");
        setStatusMessage("");
        setIsConverting(true);
        setServerLogs([]);
        try {
            const result = await handleImportProcess(() => CheckingKoreanDataUpdate(), 'Korean DB Conversion');

            if (!result.success) {
                setStatusMessage(`변환 실패: ${result.message}`);
                return;
            }
            const logs = Array.isArray(result.data.details)
                ? result.data.details
                : [result.data.details];
            setServerLogs(logs);
            setStatusMessage("Checking is successful.");
        } catch (error) {
            console.error('Error:', error);
            setError('Checking process has an error.');
            setStatusMessage('Checking failed.');
        } finally {
            setIsConverting(false);
        }
    };


    return (
        <PageLayout
            title="Checking Korean DB Update"
            description={
                <p className={`animated-text ${isConverting ? 'checking' : ''}`}>
                    {animatedText}
                </p>
            }
            onSubmit={handleConvert}
            isFileUpload={false}
            error={error}
            statusMessage={statusMessage}
            submitButtonText={isConverting ? "Checking..." : "Check"}
        >
            {/* children으로 서버 로그를 전달 */}
            {serverLogs.length > 0 && (
                <div className="server-logs-container">
                    <h3>Server Logs</h3>
                    <div className="server-logs">
                        {serverLogs.map((log, index) => (
                            <div key={index} className="log-line">
                                {log}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </PageLayout>
    );
}

export default CheckKrDataUpdate;